var React = require('react');
var ReactNative = require('react-native');

var Animated = require('./wrappers/Animated')
var createReactClass = require('create-react-class');

var Globals = require('./Globals');
var ModelConstants = require('./constants/ModelConstants.js');
var NetworkManager = require('./NetworkManager.js');
var LinkingManager = require('./wrappers/LinkingManager');
var dismissKeyboard = require('react-native-dismiss-keyboard');

import Icon from './wrappers/ReUpIcon';
var ReUpScrollView = require('./ReUpScrollView.js');
var ReUpField = require('./ReUpField.js')
var ReUpButton = require('./ReUpButton.js')
var ReUpStyle = require('./ReUpStyle.js')
var ReUpText = require('./ReUpText.js');
var ShadowView = require('./ShadowView.js');
var ProgressOverlay = require('./ProgressOverlay.js');
var LinkingManager = require('./wrappers/LinkingManager');
var AnalyticsManager = require('./AnalyticsManager');
var Hyperlink = require('./wrappers/react-native-hyperlink-wrapper');
var AddToWalletButton = require('./AddToWalletButton');
var OffsetView = require('./OffsetView');
var createReactClass = require('create-react-class');
var MK = require('./wrappers/react-native-material-kit-wrapper');

var {
  MKIconToggle,
  MKCheckbox,
  MKButton,
  MKSpinner
} = MK;

var {
  AppRegistry,
  Text,
  View,
  StyleSheet,
  AppState,
  Platform,
  Image,
  CheckBox
} = ReactNative;

function getParameterByName(url, name)
{
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(url);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}

function findGetParameter(parameterName) {
    var result = null,
        tmp = [];
    location.search
        .substr(1)
        .split("&")
        .forEach(function (item) {
          tmp = item.split("=");
          if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
        });
    return result;
}


var SimpleCreateUser = createReactClass(
{
  getDefaultProps : function()
  {
    return {
      appManager : null,
      didCompleteRegistration : ()=>{},
      storeFocus : ()=>{},
    }
  },

  getInitialState : function()
  {
    var appManager = this.props.appManager;

    return {
      layout : this.props.initialLayout,
      showPassword : false,
      nameError : false,
      firstNameError : false,
      lastNameError : false,
      emailError : false,
      emailErrorString: 'Please use a valid email',
      passwordError : false,
      shouldShowSpinner: false,
      spinnerText: '',
      optedIn: false,
      showNameDoneButton: typeof appManager._urlFirstName !== 'undefined' && typeof appManager._urlLastName !== 'undefined',
      showEmailDoneButton: typeof appManager._urlEmail !== 'undefined',
      showPasswordDoneButton: false,
      formOffset: new Animated.Value(0),
      spinnerTitle:"",
      spinnerBody:"",
      shouldDrawPage:[true,false,false]
    }
  },

  componentDidMount : function()
  {
    this.focus();

    this._linkUserID = findGetParameter("userid");
    this._linkUserHash = findGetParameter("hash");

    var appManager = this.props.appManager;
    this._firstName = typeof appManager._urlFirstName !== 'undefined' ? appManager._urlFirstName : "";
    this._lastName = typeof appManager._urlLastName !== 'undefined' ? appManager._urlLastName : "";
    this._email = typeof appManager._urlEmail !== 'undefined' ? appManager._urlEmail : "";
  },

  componentWillUnmount : function()
  {

  },

  didUpdate : function(data)
  {
  },

  focus : function()
  {
    if( this.refs.firstName ) this.refs.firstName.focus();
  },

  _email : "",
  emailChanged : function(text)
  {
    if( this.props.appManager.isValidEmail(text) ) this._enableEmailError = true;
    this._email = text;

    var newState = this.checkErrors();
    newState.showEmailDoneButton = this._email.length > 0;
    if ( this.state.emailError != newState.emailError
      || this.state.showEmailDoneButton !== newState.showEmailDoneButton )
    {
      this.setState(newState);
    }
  },

  _firstName : "",
  firstNameChanged : function(text)
  {
    var firstNameValid = this._firstName.length > 0;
    if( firstNameValid ) this._enableFirstNameError = true;

    this._firstName = text;
    var newState = this.checkErrors();
    newState.showNameDoneButton = this._firstName.length > 0 && this._lastName.length > 0;
    if ( this.state.firstNameError !== newState.firstNameError
      || this.state.showNameDoneButton !== newState.showNameDoneButton)
    {
      this.setState(newState);
    }
  },

  _lastName : "",
  lastNameChanged : function(text)
  {
    var lastNameValid = this._lastName.length > 0;
    if( lastNameValid ) this._enableLastNameError = true;

    this._lastName = text;
    var newState = this.checkErrors();
    newState.showNameDoneButton = this._firstName.length > 0 && this._lastName.length > 0;
    if ( this.state.lastNameError !== newState.lastNameError
      || this.state.showNameDoneButton !== newState.showNameDoneButton )
    {
      this.setState(newState);
    }
  },

  _password : "",
  passwordChanged : function(text)
  {
    if( this.props.appManager.isValidPassword(text) ) this._enablePasswordError = true;

    this._password = text;
    var newState = this.checkErrors();
    newState.showPasswordDoneButton = this._password.length > 0;
    if ( this.state.passwordError != newState.passwordError
      || this.state.showPasswordDoneButton !== newState.showPasswordDoneButton)
    {
      this.setState(newState);
    }
  },

  _refCode : "",
  refCodeChanged: function(text)
  {
    this._refCode = text;
  },

  _enableFirstNameError : false,
  _enableLastNameError : false,
  _enableEmailError : false,
  _enablePasswordError : false,
  _enableInlineErrors : false,
  checkErrors : function()
  {
    var firstNameError = this._enableFirstNameError && !this._firstName.length > 0;
    var lastNameError = this._enableLastNameError && !this._lastName.length > 0;
    var emailError = this._enableEmailError && !this.props.appManager.isValidEmail(this._email);
    var passwordError = false;//this._enablePasswordError && !this.props.appManager.isValidPassword(this._password);

    return {emailError:emailError, firstNameError:firstNameError, lastNameError:lastNameError, passwordError:passwordError};
  },

  showRefCodeField: function()
  {
    var thisThing = this;
    thisThing.setState({showRefCode: !thisThing.state.showRefCode})
    Animated.timing(
      this.state.fadeRefCode,
      {
        toValue: 1,
        duration: 500,
      },
    ).start(function()
    {
      thisThing.refs.refCode.focus();
    });
  },

  showEmailSpinnerAndMessage: function(email)
  {
    var thisThing = this;
    var locMan = this.props.appManager.getLocalizationManager();
    var spinnerText = locMan.localizedStringForKey("VERIFY_YOUR_ACCOUNT_TITLE", "Verify Your Account");
    var spinnerBody = locMan.localizedStringForKeyAndParams("VERIFY_YOUR_ACCOUNT_SMS_BODY", [], 'We have sent you a text message. Please check your text messages and tap the link to access your account.');
    this.checkForMailApp((can)=>
    {
      thisThing.showSpinnerAndMessage(spinnerText, spinnerBody, can);
    })
  },

  showSpinnerAndMessage: function(spinnerTitle, spinnerBody)
  {
    dismissKeyboard();
    this.goToPage(2);
    this.setState({shouldShowSpinner: true, spinnerTitle, spinnerBody})
  },

  hideSpinnerAndMessage: function()
  {
    this.setState({shouldShowSpinner: false})
  },

  _currentPageNum: 0,
  goToPage: function(pageNum, animated)
  {
    // if( typeof this._pageContainer.scrollTo !== 'undefined' ) this._pageContainer.scrollTo(0,0);
    if( this._currentPageNum == pageNum ) return;
    this._currentPageNum = pageNum;

    if( typeof animated === 'undefined' ) animated = true;

    var newOffset = pageNum*this.props.initialLayout.width;

    var shouldDrawPage = this.state.shouldDrawPage;
    shouldDrawPage[pageNum] = true;
    this.setState({shouldDrawPage});

    this.storeFocus();

    var thisThing = this;
    if( this._pageContainer != null )
    {
      this._pageContainer.scrollTo({x:newOffset, animated, completion:()=>
      {
        var fieldToFocus = null;
        if( pageNum == 0 ) fieldToFocus = thisThing._firstNameField;
        if( pageNum == 1 ) fieldToFocus = thisThing._emailField;
        if( fieldToFocus != null ) fieldToFocus.focus();
        this.setState({shouldDrawPage:[pageNum == 0,pageNum == 1,pageNum == 2]});
      }});
    }
  },

  submitPressed : function()
  {
    this._enableEmailError = true;
    this._enableFirstNameError = true;
    this._enableLastNameError = true;
    this._enablePasswordError = true;

    var newState = this.checkErrors();
    this.setState(newState);
    var thisThing = this;
    var appActions = this.props.appActions;
    if( newState.firstNameError )
    {
      this.goToPage(0);
    }
    else if( newState.lastNameError )
    {
      this.goToPage(0);
    }
    else if( newState.emailError )
    {
      this.goToPage(1);
    }
    else
    {
      var appManager = this.props.appManager;
      var email = this._email;
      var password = this._password;
      var locManager = this.props.appManager.getLocalizationManager();

      NetworkManager.createUserEmail(this.props.appManager, this._email, this._firstName, this._lastName, "", this._refCode, this.state.optedIn, this._linkUserID, this._linkUserHash,
      function(emailUser)
      {
        AnalyticsManager.logSignUpEvent(appManager, 'PassPortal', true);
        NetworkManager.login(thisThing.props.appManager, emailUser[ModelConstants.UserName], emailUser[ModelConstants.Hash], (data)=>
        {
          data[ModelConstants.Password] = data[ModelConstants.Hash];
          appManager.setCurrentUser(data, function()
          {
            console.log("loggedin?",data);
            thisThing.accountCreated();
          })
        }, (data)=>
        {
          appActions.setSpinnerShown(false);
          appActions.showNetworkErrorAlert(appActions.hideAlert, function(){})
        }, (data)=>
        {
          appActions.setSpinnerShown(false);
          appActions.showNetworkErrorAlert(appActions.hideAlert, function(){})
        });
      }, function(data)
      {
        AnalyticsManager.logSignUpEvent(appManager, 'Normal', false, {error:data.code});
        if( data.code == -4 )
        {
          // not verified or account already created, so lets try to log them in anyways
          NetworkManager.login(thisThing.props.appManager, thisThing._email, thisThing._password, function(data)
          {
            data[ModelConstants.Password] = password;
            appManager.setCurrentUser(data, function()
            {
              thisThing.accountCreated();
            })
          }, function(data)
          {
            thisThing.goToPage(1);
            thisThing.setState({emailError:true, emailErrorString:locManager.localizedStringForKey("CREATEUSER_EXISTS_2_FAIL_ALERT_BODY", "This email is already connected to an account, please try another.")});
          }, function(data)
          {
            thisThing.goToPage(1);
            thisThing.setState({emailError:true, emailErrorString:locManager.localizedStringForKey("CREATEUSER_EXISTS_2_FAIL_ALERT_BODY", "This email is already connected to an account, please try another.")});
          });
        }
        else if( data.code == -44 )
        {
          thisThing.goToPage(1);
          thisThing.setState({emailError:true, emailErrorString:locManager.localizedStringForKey("Please enter a valid referral code or clear the field.")});
        }
        else
        {
          thisThing.goToPage(1);
          thisThing.setState({emailError:true, emailErrorString:locManager.localizedStringForKey("CREATEUSER_EMAIL_INVALID_FAIL_ALERT_BODY")});
        }
      }, function(data)
      {
        AnalyticsManager.logSignUpEvent(appManager, 'Normal', false);
        appActions.setSpinnerShown(false);
        appActions.showNetworkErrorAlert(appActions.hideAlert, function(){})
      })
    }
  },

  openTosLink: function(url)
  {
    var barTintColor = this.props.appManager.getColorForKey("HeaderColor");
    var tintColor = this.props.appManager.getColorForKey("HeaderIconColor");
    LinkingManager.canOpenURL(url, function(can)
    {
      if( can )
      {
        LinkingManager.openURL(url, tintColor, barTintColor)
      }
    });
  },

  _recursiveLoginPaused: false,
  setRecursiveLoginPaused: function(paused)
  {
    if( paused != this._recursiveLoginPaused )
    {
      if( paused ) // can only pause if there is login info recorded
      {
        if( this._loginInfoForPause != null )
        {
          this._recursiveLoginPaused = paused;
          clearTimeout(this._recursiveLoginTimeout);
        }
      }
      else
      {
        this._recursiveLoginPaused = paused;
        if( this._loginInfoForPause != null ) // can only resume if login info is recorded
        {
          this.recursiveLogin(this._loginInfoForPause.appManager, this._loginInfoForPause.email, this._loginInfoForPause.password, this._loginInfoForPause.didLogin )
        }
      }
    }
  },

  _shouldContinueRecuriveLogin : false,
  _recursiveLoginTimeout : null,
  _loginInfoForPause:null,
  recursiveLogin: function(appManager, email, password, didLogin)
  {
    if( !this._shouldContinueRecuriveLogin || this._recursiveLoginPaused ) return;

    this._loginInfoForPause = {appManager:appManager, email:email, password:password, didLogin:didLogin};
    var thisThing = this;
    NetworkManager.login(appManager, email, password, function(data)
    {
      didLogin(data);
    }, function(data)
    {
      thisThing._recursiveLoginTimeout = setTimeout(()=>
      {
        thisThing.recursiveLogin(appManager, email, password, didLogin);
      }, 1000)
    }, function(data)
    {
      thisThing._recursiveLoginTimeout = setTimeout(()=>
      {
        thisThing.recursiveLogin(appManager, email, password, didLogin);
      }, 1000)
    });
  },

  storeFocus: function()
  {
    if( typeof this.props.extras !== 'undefined'
      && typeof this.props.extras.storeFocus !== 'undefined')
    {
      this.props.extras.storeFocus();
    }
  },

  nameSubmit: function()
  {
    this._enableFirstNameError = true;
    this._enableLastNameError = true;
    var errors = this.checkErrors();

    if( !errors.firstNameError && !errors.lastNameError )
    {
      this.goToPage(1);
    }
    else
    {
      this.setState(errors);
    }
  },

  emailSubmit: function()
  {
    var locManager = this.props.appManager.getLocalizationManager();
    var creatingAccountMessage = locManager.localizedStringForKey("CREATING_ACCOUNT_SPINNER_BODY", "Please wait while we register your email.");
    var creatingAccountTitle = locManager.localizedStringForKey("CREATING_ACCOUNT_SPINNER_TITLE", "Creating Account");
    this._enableEmailError = true;
    var errors = this.checkErrors();

    if( !errors.emailError)
    {
      this.showSpinnerAndMessage(creatingAccountTitle, creatingAccountMessage);
      this.submitPressed();
    }
    else
    {
      this.setState(errors);
    }
  },

  passwordSubmit: function()
  {
    var locManager = this.props.appManager.getLocalizationManager();
    var creatingAccountMessage = locManager.localizedStringForKey("CREATING_ACCOUNT_SPINNER_BODY", "Please wait while we register your email.");
    var creatingAccountTitle = locManager.localizedStringForKey("CREATING_ACCOUNT_SPINNER_TITLE", "Creating Account");
    this._enablePasswordError = true;
    var errors = this.checkErrors();

    if( !errors.passwordError)
    {
      this.showSpinnerAndMessage(creatingAccountTitle, creatingAccountMessage);
      this.submitPressed();
    }
    else
    {
      this.setState(errors);
    }
  },

  accountCreated: function()
  {
    this.props.extras.didCompleteRegistration();
  },

  optInMarketing: function()
  {
    this.setState({optedIn: !this.state.optedIn});
  },

  render: function()
  {

    var thisThing = this;
    var createUser = this;
    var appManager = this.props.appManager;
    var featureData = appManager.getFeatureForName("SimpleCreateUser");
    var locManager = this.props.appManager.getLocalizationManager();
    var appInfo = appManager.getAppInfo();
    var tosLink = appManager.getTermsLink();

    var generalColor = appManager.getColorForKey("GeneralColor");
    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
    var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
    var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
    var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
    var secondaryButtonColor = appManager.getColorForKey("ButtonSecondaryColor");
    var secondaryButtonTitleColor = appManager.getColorForKey("ButtonSecondaryTitleColor");
    var secondaryButtonBorderColor = appManager.getColorForKey("ButtonSecondaryBorderColor");
    var bannerColor = appManager.getColorForKey("FeedCardBannerColor");
    var headerColor = appManager.getColorForKey("HeaderColor");
    var headerTitleColor = appManager.getColorForKey("HeaderTitleColor");
    var primaryButtonColorLight = appManager.getColorForKey("ButtonPrimaryColor", 0.2);
    var profileColor = appManager.getColorForKey("ProfileColor");
    var profileTitleColor = appManager.getColorForKey("ProfileTitleColor");

    var firstNameLabel = locManager.localizedStringForKey("FIRSTNAME_PLACEHOLDER");
    var lastNameLabel = locManager.localizedStringForKey("LASTNAME_PLACEHOLDER");
    var emailLabel = locManager.localizedStringForKey("USERNAME_PLACEHOLDER");
    var passwordLabel = locManager.localizedStringForKey("PASSWORD_PLACEHOLDER");
    var registerButton = featureData.data.title;
    var refCodeButton = locManager.localizedStringForKey("REFERRAL_CODE_LABEL") + "?";
    var mailURL = "message://"
    var optInText = locManager.localizedStringForKeyAndParams("OPT_IN_CHECK", [appManager.appNameLong]);
    if( typeof optInText === 'undefined' || optInText == "OPT_IN_CHECK" )
    {
      optInText = "I’d like to receive exclusive deals from "+appManager.appNameLong+".";
    }

    var stripImage = appManager.absoluteResourceForPath("MyCard/strip.png");
    var headerImage = appManager.absoluteResourceForPath("Feed/header.png");
    var stripHeight = Math.min(120, this.props.initialLayout.height/3);

    var firstNameOther = {};
    if( typeof appManager._urlFirstName !== 'undefined' ) firstNameOther.defaultValue = appManager._urlFirstName;

    var lastNameOther = {};
    if( typeof appManager._urlLastName !== 'undefined' ) lastNameOther.defaultValue = appManager._urlLastName;

    var emailOther = {};
    if( typeof appManager._urlEmail !== 'undefined' ) emailOther.defaultValue = appManager._urlEmail;

    return (
      <View style={{flex:1, alignSelf:'stretch', flexDirection:'column', justifyContent:'center', height:this.props.initialLayout.height-stripHeight}}>

      <View>
        <Image style={{width:'100%', height:stripHeight, top:0, left:0, right:0}} resizeMode={"cover"} source={{uri: stripImage}} />
        <View style={{position:'absolute', top:20, left:20, right:20}}>
          <Image style={{width:'100%', height:stripHeight-40}} resizeMode={"contain"} source={{uri: headerImage}} />
        </View>
      </View>
        
        <OffsetView ref={(a)=>this._pageContainer = a} horizontal={true} style={[styles.container, { backgroundColor: profileColor}]}>
        {
          this.state.shouldDrawPage[0] ?
          <View style={{paddingRight:18, paddingLeft: 18, width:this.props.initialLayout.width, height:this.props.initialLayout.height-stripHeight, flexDirection:'column', justifyContent:'flex-start', alignItems:'stretch'}}>
            <ReUpText appManager={appManager} isTitle={true} style={{flex:0, color:profileTitleColor, textAlign:'center', paddingTop:18, paddingBottom: 18}}>
              {locManager.localizedStringForKey("INTRODUCE_YOURSELF_1_OF_2_STATEMENT")}
            </ReUpText>
            <View style={{flexDirection:'row', width:'100%', justifyContent:'center'}}>
                <ReUpField
                  invertBG={true}
                  appManager={appManager}
                  underlineColorAndroid='transparent'
                  key="firstName" ref={(a)=>this._firstNameField = a}
                  autoCapitalize={'words'}
                  autoCorrect={false}
                  onFocus={()=>{thisThing.goToPage(0)}}
                  onChangeText={this.firstNameChanged}
                  onSubmitEditing={() => {this._lastNameField.focus();}}
                  returnKeyType={'next'}
                  isInError={this.state.firstNameError}
                  placeholder={firstNameLabel}
                  style={[styles.textField]}
                  {...firstNameOther}/>
              <View style={{width:8}} />
                <ReUpField
                  invertBG={true}
                  appManager={appManager}
                  underlineColorAndroid='transparent'
                  key="lastName" ref={(a)=>this._lastNameField = a}
                  autoCapitalize={'words'}
                  autoCorrect={false}
                  onFocus={()=>{thisThing.goToPage(0)}}
                  onChangeText={this.lastNameChanged}
                  onSubmitEditing={() => {this.nameSubmit();}}
                  returnKeyType={'next'}
                  isInError={this.state.lastNameError}
                  placeholder={lastNameLabel}
                  style={[styles.textField]}
                  {...lastNameOther}/>
            </View>
            <View style={{height:26}}>
            {
              this.state.firstNameError || this.state.lastNameError ?
                <ReUpText appManager={appManager} style={{color:appManager.getErrorColor(), marginHorizontal:10, paddingTop:6}}>
                  {locManager.localizedStringForKey("FILL_IN_FULL_NAME_STATEMENT")}
                </ReUpText>
              : null
            }
            </View>
            <View style={{flex:1, marginBottom:18, alignSelf:'stretch', alignItems:'stretch', justifyContent:'flex-end'}}>
            {
              this.state.showNameDoneButton ?
                <ReUpButton appManager={appManager}maskBorderRadius={40} fontSize={20} text={locManager.localizedStringForKey("NEXT_BUTTON")} style={{minHeight: '60px', maxHeight:'60px',flex:1}} onPress={()=>
                  {
                    createUser.nameSubmit();
                  }}/>
              : null
            }
            </View>


           
          </View>
          :
          <View style={{width:this.props.initialLayout.width, height:this.props.initialLayout.height, flexDirection:'column', justifyContent:'center', alignItems:'stretch'}} />
        }
        {
          this.state.shouldDrawPage[1] ?
          <View style={{paddingRight:18, paddingLeft: 18, width:this.props.initialLayout.width, height:this.props.initialLayout.height-stripHeight, flexDirection:'column', justifyContent:'flex-start', alignItems:'stretch'}}>
            <ReUpText appManager={appManager} isTitle={true} style={{flex:0, color:profileTitleColor, textAlign:'center', paddingTop:18, paddingBottom: 18}}>
              {locManager.localizedStringForKey("INTRODUCE_YOURSELF_2_OF_2_STATEMENT")}
            </ReUpText>
            <View style={{flexDirection:'column', width:'100%'}}>
              <View style={{flexDirection:'row', width:'100%', justifyContent:'center', alignSelf:'stretch'}}>
              <ReUpField
                invertBG={true}
                appManager={appManager}
                key="email" ref={(a)=>this._emailField = a}
                underlineColorAndroid='transparent'
                autoCapitalize={'none'}
                autoCorrect={false}
                onFocus={()=>{thisThing.goToPage(1)}}
                keyboardType={'email-address'}
                onChangeText={this.emailChanged}
                onSubmitEditing={() => {this.emailSubmit();}}
                returnKeyType={'next'}
                placeholder={emailLabel}
                isInError={this.state.emailError}
                style={[styles.textField, {width:'100%'}]}
                {...emailOther}/>
              </View>
  
  <View style={{height:26}}>

            {
              this.state.emailError ?
                <ReUpText appManager={appManager} style={{color:appManager.getErrorColor(), paddingTop:6, marginHorizontal:10}}>
                  {this.state.emailErrorString}
                </ReUpText>

              : null
            }
            </View>
            { appManager.shouldContrastColor() ?
              <View style={{width:'100%', flexDirection:'row', alignSelf:'center', backgroundColor: '#F2F5F8', height:'auto', borderRadius: 3, padding:15}}>
                <MKCheckbox
                    clickHandler={this.optInMarketing}
                    checked={this.state.optedIn}
                    description={optInText}
                    fillColor={'#2F3137'}
                    textColor={'#2F3137'}
                    style={{paddingTop:0}}
                    checkboxSideLength={20}
                  ></MKCheckbox>
              </View>
         :    
              <View style={{width:'100%', flexDirection:'row', alignSelf:'center', height:55, borderRadius: 3, padding:15, height:'auto'}}>
                <MKCheckbox
                    clickHandler={this.optInMarketing}
                    checked={this.state.optedIn}
                    description={optInText}
                    fillColor={profileTitleColor}
                    textColor={profileTitleColor}
                    style={{paddingTop:0}}
                    checkboxSideLength={20}
                  ></MKCheckbox>
              </View>
        }
            </View>
            <View style={{flex:1, marginBottom:18, alignSelf:'stretch', alignItems:'stretch', justifyContent:'flex-end'}}>

            {
              this.state.showEmailDoneButton ?
                <ReUpButton appManager={appManager} text={locManager.localizedStringForKey("NEXT_BUTTON")} fontSize={20} style={{minHeight: '60px', maxHeight:'60px',flex:1}} onPress={()=>
                  {
                    createUser.emailSubmit();
                  }}/>
              : null
            }
            </View>

          </View>
          :
          <View style={{width:this.props.initialLayout.width, height:this.props.initialLayout.height, flexDirection:'column', justifyContent:'center', alignItems:'stretch'}} />
        }
        {
          this.state.shouldDrawPage[2] ?
          <View style={{paddingRight:18, paddingLeft: 18, width:this.props.initialLayout.width, height:this.props.initialLayout.height-stripHeight, flexDirection:'column', justifyContent:'flex-start', alignItems:'stretch'}}>
              <ReUpText appManager={appManager} isTitle={true} style={{flex:0, color:profileTitleColor, textAlign:'center', paddingTop:18, paddingBottom: 18}}>
              {this.state.spinnerTitle}
              </ReUpText>
            <View style={{margin:10}}>
              <ReUpText appManager={appManager} style={{color:profileTitleColor, textAlign:'center'}}>
              {this.state.spinnerBody}
              </ReUpText>
            </View>
            {
              this.state.shouldShowSpinner ?
                <View ref="spinner" key="spinner" style={{height:60}}>
                  <MKSpinner strokeColor={[appManager.getColorForKey("HeaderTitleColor"), appManager.getColorForKey("HeaderColor")]} style={{alignSelf:'center'}}/>
                </View>
              : null
            }
          </View>
          :
          <View style={{width:this.props.initialLayout.width, height:this.props.initialLayout.height, flexDirection:'column', justifyContent:'center', alignItems:'stretch'}} />
        }
        </OffsetView>
        
        
      </View>
    )
  }
});

var styles = StyleSheet.create({
  container:{
    flex: 1,
    alignSelf:'stretch',
    alignItems: 'stretch',
    flexDirection: 'row',
  },
  actionBarSpacer: {
    height:Globals.ACTION_BAR_HEIGHT,
  },
  backgroundView: {
    position: 'absolute',
    top:0, left:0, bottom:0, top:0
  },
  textField: {
    flex:1
  },
  fieldsContainer: {
    flexDirection:'column',
    paddingHorizontal:16,
    paddingVertical:10
  },
  passwordContainer: {
    flexDirection:'row',
  },
  passwordShowButton: {
    borderRadius:25,
    width:50,
    height:50,
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf:'center',
    margin:4
  },
  doneButton: {
    justifyContent:'center',
    flex:1,
    marginHorizontal:16,
    marginBottom:8
  },
});

SimpleCreateUser.dataDependencies = ["Users"];

module.exports = SimpleCreateUser;



// WEBPACK FOOTER //
// ./src/SimpleCreateUser.js